$("#search").on('click','input',function(){
    reloadProposition();
});


function reloadProposition(){
    var data = $("#search").serialize();
    $("#target").attr("hidden","");
    $("#wait").removeAttr("hidden");
    $.post(
        ajaxurl,
        {
            'action': 'ajaxload',
            'data': data
        },
        function(response){
            $("#target").html(response).removeAttr("hidden");
            $("#wait").attr("hidden","");
        }
    );
}